import { track } from "utils/analytics"

// A sign-in that ended on a server redirect (Outside) is rendered as JSON by
// the next page (layouts/web/_pack_body.html.slim); report it once.
export default function reportPendingAnalyticsEvent() {
  const element = document.getElementById("pending-analytics-event")
  if (!element) return

  element.remove()
  try {
    const { event, ...params } = JSON.parse(element.textContent)
    if (event) track(event, params)
  } catch {
    // A broken payload must not break the page
  }
}
